var map = {
	"./assets/clickable/pinterest.svg": "96ad654a2a10ed22bbd9",
	"./assets/disabled/pinterest.svg": "d1a8130df8a1340a9141",
	"./assets/original/pinterest.svg": "f291eb1ce35d37ee670a"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "ab1668252eb69ba7235e";